import { useEffect } from "react";

const Chatbot = () => {
  useEffect(() => {
    // Initialize Zoho SalesIQ
    if (!window.$zoho) {
      window.$zoho = window.$zoho || {};
      window.$zoho.salesiq = window.$zoho.salesiq || { ready: function() {} };
    }

    // Load the Zoho SalesIQ script if not already loaded
    const existingScript = document.getElementById('zsiqscript');
    if (!existingScript) {
      const script = document.createElement('script');
      script.id = 'zsiqscript';
      script.src = 'https://salesiq.zohopublic.com/widget?wc=siq6b4b37c2ec668cf52b51b5aa0563c46fa41f11cd5ad8bd0f97ed74d39ede1628706091e82b0657ba548ac6cde2d77470';
      script.defer = true;
      document.body.appendChild(script);
    }

    // Cleanup function
    return () => {
      // Note: We don't remove the script on unmount as it should persist across route changes
    };
  }, []);

  return null; // This component doesn't render any visible UI - the widget is injected by Zoho
};

export default Chatbot;

// Extend the Window interface for TypeScript
declare global {
  interface Window {
    $zoho: any;
  }
}